import React from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
// import ReactDOM from 'react-dom';
import style from './style.module.css';
import Item from './Item';
import NumberFormat from 'react-number-format';
// import CurierLocation from '../CurierLocation';

@inject(store => {
    const { myShopApiStore } = store;
    return { myShopApiStore };
})

@observer
class Basket extends React.Component {
    
    handleAddToCartClick = () => {
        const { basketHistory, addToCart, closeCartItemForm} = this.props.myShopApiStore;

        if(basketHistory){
            basketHistory.products.forEach(product => {
                addToCart(product.shopProduct, product.unitType);
                closeCartItemForm();
            }); 
        }
    }

    render() {
        const { basketHistory } = this.props.myShopApiStore;
        const { shopData } = this.props.myShopApiStore;
        const { currencyName } = shopData.country;

        const deliveryCost = basketHistory?.deliveryCost??0;
        const totalToPay = basketHistory?.totalPay??0;
        const totalCost = basketHistory?.orderRecountedTotal - deliveryCost;
        const orderPromotions = basketHistory?.orderPromotions;
        const totalTax = basketHistory?.totalTax;
        const serviceFee = basketHistory?.serviceFee??null;
        const totalText = orderPromotions?.length > 0 ? ('Product cost before discounts') : (
            totalToPay != totalCost ? ('The cost of products') : ('Total to pay')
        );
        
        const { t } = this.props;
        return (
            <div className={style.Container}>
                <div className={style.CancelXBtn}>
                    <span onClick={this.props.hideBasket}>✕</span>
                </div>
                <div className={style.OrderNumber} >{` ${t('_order number')} #${basketHistory?.id}`}</div>
                <div className={style.List}>
                    {
                        basketHistory?.products?.map((item, index) => 
                            <Item item={item} index={index} key={`p_${index}_${item.id}`} />
                        )
                    }
                    <div className={style.OrderSummaryTable}>
                        <table>
                            <tbody>
                                <tr>
                                    <td>{t(totalText)}</td>
                                    <td><NumberFormat value={ totalCost } prefix={currencyName} decimalScale={2} fixedDecimalScale={true} displayType={'text'} /></td>
                                </tr>

                                {
                                    orderPromotions && orderPromotions?.length > 0 && (() => {
                                        const discount_value = orderPromotions.reduce((acc, promo) => {
                                            const original = parseFloat(promo.totalOriginal) || 0;
                                            const final = parseFloat(promo.total) || 0;
                                            return acc + (original - final);
                                        }, 0);

                                        if (discount_value > 0) {
                                            return (
                                                <tr>
                                                    <td>{t('Savings') + ' ' + t('Discount')}</td>
                                                    <td>
                                                        <NumberFormat 
                                                            value={discount_value} 
                                                            prefix={currencyName} 
                                                            decimalScale={2} 
                                                            fixedDecimalScale={true} 
                                                            displayType={'text'} 
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        }
                                        return null;
                                    })()
                                }

                                {
                                    basketHistory?.couponId && (
                                        <tr>
                                            <td>{t('Coupon discount')}: { basketHistory?.coupon?.code}</td>
                                            <td>{basketHistory?.coupon?.discountFormat}</td>
                                        </tr>
                                    )
                                }

                                {
                                    basketHistory?.orderType == 'delivery' && ( 
                                    <tr>
                                        <td>{t('Delivery cost')}</td>
                                        <td><NumberFormat value={ deliveryCost } prefix={currencyName} decimalScale={2} fixedDecimalScale={true} displayType={'text'} /></td>
                                    </tr>
                                    )
                                }

                                {
                                    serviceFee != null && (
                                        <tr>
                                            <td>{shopData.serviceFeeName??'Service Fee'}</td>
                                            <td><NumberFormat value={ serviceFee } prefix={currencyName} decimalScale={2} fixedDecimalScale={true} displayType={'text'} /></td>
                                        </tr>
                                    )
                                }

                                {
                                    totalTax != null && (
                                        <tr>
                                            <td>{t('Tax')}</td>
                                            <td><NumberFormat value={ totalTax } prefix={currencyName} decimalScale={2} fixedDecimalScale={true} displayType={'text'} /></td>
                                        </tr>
                                    )
                                }

                                {
                                    (totalTax != null || totalText != 'Total to pay') && (
                                        <tr>
                                            <td><strong>{t(totalTax != null ? 'Grand Total' :'Total to pay')}</strong></td>
                                            <td><strong><NumberFormat value={ totalToPay } prefix={currencyName} decimalScale={2} fixedDecimalScale={true} displayType={'text'} /></strong></td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Basket);